export default __webpack_public_path__ + "static/media/logo-tap.cf9bd8fc.svg";